const template = `
	<div class="date-range">
		<div>
			<div class="dr-sidebar">
				<div v-for="item in sideItems" class="dr-side-item">
					<span class="link" @click="applySideItem(item)">{{ item.text }}</span>
				</div>
			</div>
			<div class="dr-calendars">
				<calendar v-model="startDate"></calendar>
				<calendar v-model="endDate"></calendar>
			</div>
		</div>
		<div class="calendars-bottom">
			<span class="link dr-apply-btn" @click="applyDates">{{ ii('APPLY') }}</span>
		</div>
	</div>
`;

export default {
	template,
	props: ['value', 'type'],
	data() {
		return {
			startDate: null,
			endDate: null
		};
	},
	computed: {
		sideItems() {
			let m = moment().tz(this.app.tz);
			let today = m.format('YYYY-MM-DD');

			let monthEnd = m.clone().endOf('month').format('YYYY-MM-DD');
			let prevMonthEnd = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');

			return [
				{
					text: this.ii('TODAY'),
					startDate: today,
					endDate: today
				},
				{
					text: this.ii('LAST_WEEK'),
					startDate: m.subtract(7, 'days').format('YYYY-MM-DD'),
					endDate: today
				},
				{
					text: this.ii('THIS_MONTH'),
					startDate: monthEnd.slice(0, 7) + '-01',
					endDate: monthEnd
				},
				{
					text: this.ii('PREV_MONTH'),
					startDate: prevMonthEnd.slice(0, 7) + '-01',
					endDate: prevMonthEnd
				}
			];
		}
	},
	methods: {
		applyDates() {
			let value = this.startDate  + '_' + this.endDate;
			this.$emit('input', value);
			this.$emit('change', { value });
		},
		applySideItem(item) {
			this.startDate = item.startDate;
			this.endDate = item.endDate;
		}
	},
	mounted() {
		let range = this.parseDateRange(this.value, this.type);
		this.startDate = range.from;
		this.endDate = range.to;
	}
};